// Environment Variables
// import './envLoader';

// Sentry
import Raven from 'raven-js';

// Styling
import './theme.scss';
import './theme.js';

// React.js
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
 
// Application
import './helpers.js';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

// Icons
import fontawesome from '@fortawesome/fontawesome'

import {
	faForward,
	faExclamationTriangle,
	faCheckCircle,
	faTimes,
	faPencilAlt,
	faClipboardCheck,
	faCheck, 
	faThumbsUp, 
	faUser, 
	faSquare, 
	faQuestion, 
	faCircleNotch, 
	faAngleDoubleUp, 
	faAngleDoubleDown, 
	faInfoCircle,
	faEnvelope,
	faKey
} from '@fortawesome/free-solid-svg-icons'

Raven.config(process.env.REACT_APP_SENTRY_DSN).install();

const icons = [
	faTimes, faPencilAlt, faClipboardCheck, faCheck, faThumbsUp, 
	faUser, faSquare, faQuestion, faCircleNotch, faAngleDoubleUp, 
	faAngleDoubleDown, faInfoCircle, faEnvelope, faKey, faCheckCircle,
	faExclamationTriangle, faForward
];

for (var icon in icons) {
	fontawesome.library.add(icons[icon])
}

// Rendering
ReactDOM.render(
	<Router>
		<App />
	</Router>, 
	document.getElementById('root')
);

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js